/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import PropTypes from 'prop-types';

const staticCss = css`
  padding: 16px;
`;

export const CardBody = ({ children, ...rest }) => (
  <section {...rest} css={staticCss}>
    {children}
  </section>
);

CardBody.propTypes = {
  children: PropTypes.node,
};
CardBody.defaultProps = {
  children: null,
};
